import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import MockUpUtil from 'edge/api/gw-portals-util-js/MockUpUtil';
import MetadataDrivenUtil from 'edge/api/gw-portals-driven-ui-js/MetadataDrivenUtil';
import VinLookupService from '../../../../../../../../common/js/src/edge/policyjob/services/VinLookupService';

const mockUpUtil = new MockUpUtil();
const fn = ($filter, $scope, $translate, ModalService, StateUtils, submissionViewModel, VinLookupService) => {
    const ctrl = Object.create(BaseCtrl);
    let submissionVm = submissionViewModel();
    const puwModel = submissionVm.lobData.puw_PSA.value;
    const accountHolder = submissionVm.value.getAccountHolderPerson();
    const flowModel = StateUtils.activeDataForState(true).flowModel;
    $scope.checkValidation = '';
    $scope.showErrorMsg = false;
    $scope.enabled = false;
    window.producerCodeCountry = submissionVm.baseData.accountHolder.value.producerCodeCountry;
    window.producerCodeLabel = submissionVm.baseData.accountHolder.producerCodeLabel.value;
    window.isNscProducerCode = submissionVm.baseData.value.nscProducerCode;
    $scope.periodStatus = submissionVm.baseData.value.periodStatus;
    $scope.existingSubmission = submissionVm.baseData.accountHolder.value.existingSubmission;
    $scope.isValidMileage = false;
    ctrl.defineWatches = () => {
        $scope.$watch(() => submissionViewModel().value, () => {
            submissionVm = submissionViewModel();
            $scope.vehicles = submissionVm.lobData.puw_PSA.coverables.vehicles;
        }, true);
    };

    const typeOfEnergies = { "D": "Diesel", "E": "Electric", "H": "Hybrid", "A": "Other", "B": "Essence", "Z": "Notdefined" };
    const makes = { "00": "fiat", "30": "citroen", "31": "peugeot", "33": "ds", "43": "opel", "55": "chrysler", "56": "dodge", "57": "jeep", "58": "ram", "66": "abarth", "70": "lancia", "77": "fiat", "83": "alfaromeo" };
    const alfaRomeoModels = ["147", "159", "4CSpider", "4C", "Brera", "GiuliaQuadrifoglio", "Giulia", "Giulietta", "Mito", "StelvioQuadrifoglio", "Stelvio", "Tonale", "GT"];
    ctrl.init = () => {
        $scope.isMetadataDrivenUIEnabled = MetadataDrivenUtil.isStepEnabled('puw', 'puw-vehicle-details');
        $scope.page = {
            readonly: false
        };
        let selectedVehicle;

        $scope.vehicles = submissionVm.lobData.puw_PSA.coverables.vehicles;
        $scope.URL = submissionVm.baseData.accountHolder.url.value;

        /**
         *  If there are no vehicles in the table, initialise an empty vehicle to be populated,
         *  otherwise on first enter, when there are vehicles, pick the first one from the array.
         */
        if (puwModel.coverables.vehicles.length === 0) {
            selectedVehicle = puwModel.coverables.createVehicle(accountHolder);
            //console.log("Inside new vehicle: " + $scope.URL);
            //const obj = JSON.parse('{"name":"John", "age":30, "city":"New York"}');
            //console.log(obj.age);
            if ($scope.URL != undefined) {
                const obj = JSON.parse($scope.URL);
                selectedVehicle.vin = obj.Vin;
                selectedVehicle.license = obj.LicensePlate;
                selectedVehicle.vehicleType = obj.VehicleType;
                if (obj.FirstRegistrationDate != undefined && obj.FirstRegistrationDate.split("-").length == 3) {
                    const frdArray = obj.FirstRegistrationDate.split("-");
                    selectedVehicle.firstRegistrationDate = {
                        day: frdArray[2].split(" ")[0],
                        month: parseInt(frdArray[1]) - 1,
                        year: frdArray[0]
                    };
                    selectedVehicle.makerWarrantyEnd = {
                        day: frdArray[2].split(" ")[0],
                        month: parseInt(frdArray[1]) - 1,
                        year: parseInt(frdArray[0]) + 2
                    };
                }
                selectedVehicle.make = makes[obj.Make];
                if (obj.Make === "83") { // Mapping models for Alfa Romeo
                    let model = obj.Model.replaceAll(" ", "");
                    if (model.includes("SPORTWAGON")) {
                        selectedVehicle.alpharomeoModel_PSA_Temp = "159";
                    }
                    for (let i = 0; i < alfaRomeoModels.length; i++) {
                        if (model.includes(alfaRomeoModels[i])) {
                            selectedVehicle.alpharomeoModel_PSA_Temp = alfaRomeoModels[i];
                            break;
                        }
                    }
                } else { // Mapping models for other than Alfa Romeo
                    selectedVehicle.model = obj.Model;
                    //selectedVehicle.lanciaModel_PSA_Temp = obj.Model;
                }

                selectedVehicle.typeOfEnergy = typeOfEnergies[obj.TypeofEnergy];
                if (obj.CarPower != undefined) {
                    if (obj.Country == 'IT' || obj.Country == 'DE') {
                        selectedVehicle.carPowerKW = parseInt(obj.CarPower);
                        selectedVehicle.carPowerKWIT = parseInt(obj.CarPower);
                    } else {
                        selectedVehicle.carPower = parseInt(obj.CarPower);
                    }
                }
                if (obj.Mileage != undefined) {
                    selectedVehicle.currentMileage = parseInt(obj.Mileage);
                }
                if (obj.kms != undefined) {
                    selectedVehicle.makerWarrantyKilometers = parseInt(obj.kms);
                }
                selectedVehicle.vehicleSpecificities = obj.spec;
            }
        } else {
            selectedVehicle = puwModel.coverables.vehicles[0];
            //console.log("Inside existing vehicle: ");
        }

        // This function is used to remove prefill data needed to obtain a quote for streamlined submissions.
        const sanitisePrefillDataFromQuickQuote = (vehicles) => {
            const licenceMockData = mockUpUtil.getMockData('lobData.puw.coverables.drivers.driver.license');
            const vehicleVinMockData = mockUpUtil.getMockData('lobData.puw.coverables.vehicles.vehicle.vin');

            const vehicle = _.find(vehicles, {
                license: licenceMockData
            });
            if (angular.isDefined(vehicle)) {
                vehicle.license = undefined;
                vehicle.costNew.amount = undefined;
                if (vehicle.vin === vehicleVinMockData) {
                    vehicle.vin = undefined;
                }
            }
        };
        sanitisePrefillDataFromQuickQuote(puwModel.coverables.vehicles);
        VinLookupService.vinSearchTempData.isLicenseSearchComplete = false;
        VinLookupService.vinSearchTempData.noResultOnLicenseSearch = false;
        VinLookupService.vinSearchTempData.isVinSearchCompleted = false;
        VinLookupService.vinSearchTempData.multipleVinResults = false;
        VinLookupService.vinSearchTempData.emptyVinSearchData = false;
        VinLookupService.vinSearchTempData.revalidateError = false;
        VinLookupService.nscVINValidated = true;
        VinLookupService.nscSellerSiteValidated = true;
        VinLookupService.nscBrandRRDI = undefined;
        $scope.page.selectedVehicle = submissionVm.lobData.puw_PSA.coverables.vehicles.findFirstElement(selectedVehicle);
        $scope.disableDefaults();
    };

    $scope.disableDefaults = () => {
        VinLookupService.disableData.make = false;
        VinLookupService.disableData.model = false;
        VinLookupService.disableData.energy = false;
        VinLookupService.disableData.carPower = false;
        VinLookupService.disableData.vehicleSpec = false;
        VinLookupService.licenseSearchResponseFieldsCount = 0;
        VinLookupService.vinSearchResponseFieldsCount = 0;
        VinLookupService.nscNoVehicleInfo = false;
        VinLookupService.nscMoreResultFound = false;
        VinLookupService.nscValuesUpdated = false;
    }

    $scope.showPartialDataWarning = () => {
        if (!VinLookupService.nscVINValidated) {
            return false;
        }
        if (VinLookupService.vinSearchTempData.isLicenseSearchComplete &&
            !VinLookupService.vinSearchTempData.noResultOnLicenseSearch &&
            !VinLookupService.vinSearchTempData.isVinSearchCompleted) {
            if (VinLookupService.licenseSearchResponseFieldsCount > 0 &&
                VinLookupService.licenseSearchResponseFieldsCount != 6) {
                return true;
            }
        } else if (VinLookupService.vinSearchTempData.isVinSearchCompleted &&
            !VinLookupService.vinSearchTempData.multipleVinResults) {
            if (VinLookupService.vinSearchResponseFieldsCount > 0 &&
                VinLookupService.vinSearchResponseFieldsCount != 5) {
                return true;
            }
        }
        return false;
    }

    $scope.showFullDataWarning = () => {
        if (!VinLookupService.nscVINValidated) {
            return false;
        }
        if (VinLookupService.vinSearchTempData.isLicenseSearchComplete &&
            !VinLookupService.vinSearchTempData.noResultOnLicenseSearch &&
            !VinLookupService.vinSearchTempData.isVinSearchCompleted) {
            if (VinLookupService.licenseSearchResponseFieldsCount > 0 &&
                VinLookupService.licenseSearchResponseFieldsCount == 6) {
                return true;
            }
        } else if (VinLookupService.vinSearchTempData.isVinSearchCompleted &&
            !VinLookupService.vinSearchTempData.multipleVinResults) {
            if (VinLookupService.vinSearchResponseFieldsCount > 0 &&
                VinLookupService.vinSearchResponseFieldsCount == 5) {
                return true;
            }
        }
        return false;
    }

    $scope.showNSCVINError = () => {
        return VinLookupService.nscNoVehicleInfo;
    }
    $scope.showMileageErrorforIT = () => {
        $scope.isValidMileage = false;
        const mileageIt =  puwModel.coverables.vehicles[0].currentMileage;
        const isproducerCodeCountryIT = submissionVm.baseData.accountHolder.value.producerCodeCountry;
        if(isproducerCodeCountryIT == 'IT' && mileageIt >= 200000){
            $scope.isValidMileage = true;
        }
        return $scope.isValidMileage;
    }
    $scope.showNSCMultiRecordWarning = () => {
        return VinLookupService.nscMoreResultFound;
    }
    $scope.showNSCValuesUpdatedMsg = () => {
        return VinLookupService.nscValuesUpdated;
    }

    ctrl.addVehicle = (form) => {
        if (ctrl._isValid(form)) {
            const newVehicle = puwModel.coverables.createVehicle();
            $scope.page.selectedVehicle = submissionVm.lobData.puw_PSA.coverables.vehicles.findFirstElement(newVehicle);
            $scope.page.readonly = false;
            $scope.$broadcast('update-form');
            form.submitted = false;
            form.setPristine();
            form.$setUntouched();
        }
    };

    ctrl.removeVehicle = (vehicle) => {
        const confirmationMsg = {
            key: 'quoteandbind.pa.controllers.PAVehicleDetailsCtrl.RemoveConfirmationMsg',
            args: {
                vehicle: vehicle.getDisplayName(undefined, $filter)
            }
        };
        ModalService.showWarning(
            'quoteandbind.pa.controllers.PAVehicleDetailsCtrl.Remove Vehicle?', confirmationMsg, '',
            $filter('translate')('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.Yes'),
            'gw-btn-primary',
            $filter('translate')('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.No')
        )
            .result.then(() => {
                let vehicleObj;
                if (submissionVm.lobData.puw_PSA.coverables.vehicles.findFirstElement(vehicle) === $scope.page.selectedVehicle) { // If we're about to delete the current vehicle, show the first vehicle or blank
                    if (puwModel.coverables.vehicles.length > 1) {
                        if (puwModel.coverables.vehicles[0] !== vehicle) {
                            vehicleObj = puwModel.coverables.vehicles[0];
                        } else {
                            vehicleObj = puwModel.coverables.vehicles[1];
                        }
                    }
                } else {
                    vehicleObj = $scope.page.selectedVehicle.value;
                }
                puwModel.coverables.removeVehicle(vehicle);
                $scope.page.selectedVehicle = submissionVm.lobData.puw_PSA.coverables.vehicles.findFirstElement(vehicleObj);
                $scope.$broadcast('update-form');
            });
    };

    ctrl.isVehicleValid = () => {
        return _.every($scope.vehicles.children, (vehicle) => {
            return vehicle.aspects.subtreeValid;
        });
    };

    ctrl.editVehicle = (vehicle, form) => { // Validate the current input, and if correct, save the current changes and select the next vehicle
        if (ctrl._isValid(form)) {
            $scope.page.selectedVehicle = submissionVm.lobData.puw_PSA.coverables.vehicles.findFirstElement(vehicle);
        } else {
            form.submitted = true;
        }
        $scope.page.readonly = false;
    };

    ctrl._isVehicleEmpty = ({
        vin, model, make, year, licenseState, costNew
    }) => {
        const nonLicenseFieldsEmpty = [vin, model, make, year, costNew.amount].every(prop => {
            return prop === null || prop === undefined || prop === '';
        });
        const licenseStateEmpty = licenseState === null || licenseState === undefined || licenseState === accountHolder.primaryAddress.state;
        return nonLicenseFieldsEmpty && licenseStateEmpty;
    };

    ctrl._isValid = () => {
        if (!ctrl.isVehicleValid()) {
            return false;
        }
        if (!$scope.isMetadataDrivenUIEnabled) {
            const licenceMatchedVehicle = ctrl._ensureUniqueLicensePlate($scope.page.selectedVehicle.value);
            const vinMatchedVehicle = ctrl._ensureUniqueVin($scope.page.selectedVehicle.value);
            if (licenceMatchedVehicle) {
                const licenceMatchedMsg = $translate('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.LicenceMatchMsg', {
                    licenceMatchedVehicle: licenceMatchedVehicle.getDisplayName(undefined, $filter)
                });
                ModalService.showError('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.Licence plate is not unique', licenceMatchedMsg);
                return false;
            } else if (vinMatchedVehicle) {
                const vinMatchedMsg = $translate('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.VinMatchMsg', {
                    vinMatchedVehicle: vinMatchedVehicle.getDisplayName(undefined, $filter)
                });
                ModalService.showError('quoteandbind.pa.controllers.PAVehicleDetailsCtrl.VIN is not unique', vinMatchedMsg);
                return false;
            }
        }
        return true;
    };

    ctrl._ensureUniqueLicensePlate = (vehicle) => {
        if (vehicle.license) {
            const vehicleMatch = _.filter(puwModel.coverables.vehicles, {
                license: vehicle.license
            });
            if (!vehicleMatch) {
                return undefined;
            } else if (vehicleMatch.length === 1) {
                return vehicleMatch[0] !== vehicle ? vehicleMatch[0] : undefined;
            }
            return _.find(vehicleMatch, (v) => {
                return v !== vehicle;
            });
        }
    };

    ctrl._ensureUniqueVin = (vehicle) => {
        const vehicleMatch = _.filter(puwModel.coverables.vehicles, {
            vin: vehicle.vin
        });
        if (!vehicleMatch) {
            return undefined;
        } else if (vehicleMatch.length === 1) {
            return vehicleMatch[0] !== vehicle ? vehicleMatch[0] : undefined;
        }
        return _.find(vehicleMatch, (v) => {
            return v !== vehicle;
        });
    };
    ctrl._setVehicleDefaults = () => {
        _.forEach(puwModel.coverables.vehicles, (vehicle) => {
            vehicle.primaryUse = 'commuting';
        });
    };

    ctrl.enableEmptyVinWarning = function () {
        return VinLookupService.vinSearchTempData.emptyVinSearchData;
    }

    ctrl.checkVar = function (variable) {
        return variable != undefined && variable != "";
    }

    ctrl.checkMakeModel = function () {
        let vehicle = puwModel.coverables.vehicles[0];
        if (ctrl.checkVar(vehicle.make)) {
            if (vehicle.make == 'alfaromeo' && ctrl.checkVar(vehicle.alpharomeoModel_PSA_Temp)) {
                return true;
            } else if (vehicle.make == 'lancia' && ctrl.checkVar(vehicle.lanciaModel_PSA_Temp)) {
                return true;
            } else if (vehicle.make != 'alfaromeo' && vehicle.make != 'lancia' && ctrl.checkVar(vehicle.model)) {
                return true;
            }
        }
        return false;

    }

    ctrl.checkVINMandatoryFields = function () {
        let vehicle = puwModel.coverables.vehicles[0];
        if (ctrl.checkVar(vehicle.vin) && ctrl.checkMakeModel() &&
            ctrl.checkVar(vehicle.typeOfEnergy) && ctrl.checkVar(vehicle.vehicleSpecificities)) {
            return true;
        }
    }

    ctrl.checkLicenseMandatoryFields = function () {
        let vehicle = puwModel.coverables.vehicles[0];
        if (ctrl.checkVar(vehicle.vin) && ctrl.checkVar(vehicle.firstRegistrationDate) &&
            ctrl.checkVar(vehicle.license) && ctrl.checkMakeModel() &&
            ctrl.checkVar(vehicle.typeOfEnergy) && ctrl.checkVar(vehicle.vehicleSpecificities)) {
            return true;
        }
    }

    ctrl.enableNext = function () {
        if (!VinLookupService.nscSellerSiteValidated) {
            return false;
        }
        if (!VinLookupService.nscVINValidated) {
            return false;
        }
        if (window.isNscProducerCode) {
            let vehicle = puwModel.coverables.vehicles[0];
            if (VinLookupService.nscVin != undefined && VinLookupService.nscVin != vehicle.vin) {
                return false;
            }
            if (VinLookupService.nscBrandRRDI != undefined && VinLookupService.nscBrandRRDI != vehicle.sellerSite) {
                return false;
            }
        }
        if ((!VinLookupService.vinSearchTempData.noResultOnLicenseSearch &&
        VinLookupService.vinSearchTempData.isLicenseSearchComplete) ||
            VinLookupService.vinSearchTempData.isVinSearchCompleted ||
            $scope.periodStatus === 'Quoted' || $scope.existingSubmission) {
            let vehicle = puwModel.coverables.vehicles[0];
            if (vehicle.producerCodeCountry == 'DE' && ctrl.checkVar(vehicle.carPowerKW)
                && ctrl.checkVINMandatoryFields()) {
                return true;
            } else if (vehicle.producerCodeCountry == 'IT' && ctrl.checkVar(vehicle.carPowerKWIT)
                && (ctrl.checkVINMandatoryFields() || ctrl.checkLicenseMandatoryFields())) {
                return true;
            } else if (ctrl.checkVar(vehicle.carPower) &&
                (ctrl.checkVINMandatoryFields() || ctrl.checkLicenseMandatoryFields())) {
                return true;
            }
            return false;
        }
        return false;
    }

    ctrl.revalidateError = function () {
        return VinLookupService.vinSearchTempData.revalidateError;
    }
    ctrl.next = function (callback) {
        $scope.form.submitted = true;
        $scope.showMileageErrorforIT();
        if($scope.isValidMileage == true) {
           // puwModel.coverables.vehicles[0].make = undefined;
            return false;
        }
        if(puwModel.coverables.vehicles[0].sellerSite == "") {
           puwModel.coverables.vehicles[0].sellerSite = null;
        }
        if(window.producerCodeLabel == 'DSCertified' && puwModel.coverables.vehicles[0].make != 'ds') {
            puwModel.coverables.vehicles[0].make = undefined;
        }
        if(window.producerCodeLabel == 'LanciaCertifed' && puwModel.coverables.vehicles[0].make != 'lancia') {
            puwModel.coverables.vehicles[0].make = undefined;
        }
        if(window.producerCodeLabel == 'alfaRomeoCertified' && puwModel.coverables.vehicles[0].make != 'alfaromeo') {
            puwModel.coverables.vehicles[0].make = undefined;
        }
        if (puwModel.coverables.vehicles[0].make == 'ds') {
            puwModel.coverables.vehicles[0].model = puwModel.coverables.vehicles[0].model.toUpperCase();
        }
        //UCWAR-650 Lancia Italy
        if (puwModel.coverables.vehicles[0].producerCodeCountry == 'IT') {
            puwModel.coverables.vehicles[0].carPower = 0;
        }
        //UCWAR-2028 Vehicle data to be filled in by external system
        if (!VinLookupService.vinSearchTempData.isVinSearchCompleted &&
                (VinLookupService.vinSearchTempData.noResultOnLicenseSearch ==
                        VinLookupService.vinSearchTempData.isLicenseSearchComplete)) {
            VinLookupService.vinSearchTempData.revalidateError = true;
            return;
        } else {
            VinLookupService.vinSearchTempData.revalidateError = false;
        }
        if (!ctrl._isValid() || $scope.form.valid === false) {
            callback();
            return;
        }

        if (puwModel.coverables.vehicles[0].make == 'alfaromeo' &&
            submissionVm.baseData.accountHolder.producerCodeLabel.value == 'alfaRomeoCertified' &&
            (puwModel.coverables.vehicles[0].carPower > 999 ||
                puwModel.coverables.vehicles[0].carPowerKW > 999
                || puwModel.coverables.vehicles[0].carPowerKWIT > 999)) {
            console.log("Car Power value should not be more than 999.");
            return; //UCWAR-1928
        } else if (puwModel.coverables.vehicles[0].make != 'alfaromeo' ||
            submissionVm.baseData.accountHolder.producerCodeLabel.value != 'alfaRomeoCertified') {
            if (puwModel.coverables.vehicles[0].producerCodeCountry == 'FR') {
                if (puwModel.coverables.vehicles[0].carPower > 510) {
                    console.log("FR and 510 logic.");
                    return;
                }
            } else if (puwModel.coverables.vehicles[0].producerCodeCountry == 'ES') {
                if (puwModel.coverables.vehicles[0].carPower > 380) {
                    console.log("ES and 380 logic.");
                    return;
                }
            } else if (puwModel.coverables.vehicles[0].producerCodeCountry == 'DE') {
                if (puwModel.coverables.vehicles[0].carPowerKW > 300) {
                    console.log("DE and 300 logic.");
                    return;
                }
            } else if (puwModel.coverables.vehicles[0].producerCodeCountry == 'IT') {
                if (puwModel.coverables.vehicles[0].carPowerKWIT > 249) {
                    console.log("IT and 249 logic.");
                    return;
                }
            }
        }
        ctrl._setVehicleDefaults();
        flowModel.next(submissionVm);
    };

    ctrl.previous = function () {
        // remove empty vehicle if no changes have been made
        if (puwModel.coverables.vehicles.length === 1 && ctrl._isVehicleEmpty(puwModel.coverables.vehicles[0])) {
            puwModel.coverables.vehicles.pop();
        }
        flowModel.previous(submissionVm);
    };

    ctrl.cancel = function () {
        flowModel.cancel(submissionVm, { withdraw: true });
    };

    ctrl.save = function (form) {
        form.submitted = true;
        if (form.invalid) {
            return;
        }
        if (puwModel.coverables.vehicles[0].make == 'ds') {
            puwModel.coverables.vehicles[0].model = puwModel.coverables.vehicles[0].model.toUpperCase();
        }
        //UCWAR-650 Lancia Italy
        if (puwModel.coverables.vehicles[0].producerCodeCountry == 'IT') {
            puwModel.coverables.vehicles[0].carPower = 0;
        }
        ctrl._setVehicleDefaults();
        flowModel.cancel(submissionVm, { savingDraft: true });
    };
    return ctrl.create($scope);
};

fn.$inject = ['$filter', '$scope', '$translate', 'ModalService', 'StateUtils', 'submissionViewModel', 'VinLookupService'];
export default fn;
